import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { cn } from "../../lib/utils";

interface LinkProps {
  to: string;
  children?: React.ReactNode;
  className?: string;
  state?: any;
  external?: boolean;
  variant?: "default" | "primary" | "subtle" | "nav";
  underline?: "always" | "hover" | "none";
}

export function Link({ 
  className, 
  variant = "default",
  underline = "hover",
  children, 
  to, 
  state,
  external = false 
}: LinkProps) {
  const variantClasses = {
    default: "text-foreground hover:text-primary",
    primary: "text-primary hover:text-primary-hover",
    subtle: "text-paragraph hover:text-foreground",
    nav: "text-foreground hover:text-primary",
  };

  const underlineClasses = {
    always: "underline",
    hover: "hover:underline",
    none: "no-underline",
  };

  const classes = cn(
    "transition-colors underline-offset-4",
    variantClasses[variant],
    underlineClasses[underline],
    className
  );

  if (external) {
    return (
      <a href={to} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={to} state={state} className={classes}>
      {children}
    </RouterLink>
  );
}